var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',_vm._g(_vm._b({staticClass:"yz-tabs",class:_vm.tabsClasses,style:(_vm.tabsStyle),attrs:{"value":_vm.value},on:{"change":_vm.handleChange}},'v-tabs',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }